module.exports = __webpack_public_path__ + "components/flag/static/square/mc-5aa1644530385c7fd9c40788cb06e0f9.svg";